export default __webpack_public_path__ + "static/media/email.2f9ef17b.svg";